<template>
	<div>
		<vs-row>
			<vs-col vs-lg="12" vs-sm="12" vs-xs="12">
				<div class="mb-2" style="border: 1px solid #e4e4e4; border-radius: 10px">
					<floating-buttons
						:titleHeader="$t('BreakTable.Action')"
						:cancelText="$t('MODULE_PERMISSION.Cancel')"
						:saveText="isEditActive ? SubmitButtonTitleEdit : SubmitButtonTitleCreate"
						:disabledSave="submitButtonDisabled"
						@save="submitForm"
						@cancel="cancel"
					/>
				</div>
				<form>
					<vx-card class="mt-2" :cardBorder="true" :noShadow="true">
						<div class="vx-row mb-6">
							<div class="vx-col lg:w-1/2 w-full">
								<vs-row>
									<vs-col class="mb-6">
										<vs-input
											name="name"
											class="w-full"
											:label="$t('Deposits.Table.Name')"
											v-model="depotItem.name"
											v-validate="'required'"
										/>
										<span class="text-danger text-sm" v-show="errors.has('name')">{{
											$t("Deposits.Form.ValidMessages.Name")
										}}</span>
									</vs-col>
									<vs-col>
										<small>{{ $t("BreakTable.Description") }}</small>
										<vs-textarea
											name="description"
											type="text"
											class="w-full"
											icon-pack="feather"
											icon="icon-message-square"
											icon-no-border
											v-model="depotItem.description"
										/>
									</vs-col>
									<vs-col>
										<vs-row>
											<vs-col vs-w="12">
												<vs-input
													name="address"
													class="w-full"
													:disabled="!department"
													:label="$t('Divipola.Address')"
													v-model="address"
													v-validate="'required'"
												/>
												<span class="text-danger text-sm" v-show="errors.has('address')">{{
													$t("Deposits.Form.ValidMessages.Address")
												}}</span>
											</vs-col>
										</vs-row>
										<vs-row class="mt-4">
											<vs-col vs-w="6">
												<label class="vs-input--label">{{ $t("Divipola.Country") }}</label>
												<vs-input
													v-show="false"
													name="country"
													class="d-none"
													v-model="selectedCountry.value"
													v-validate="'required'"
												/>
												<v-select
													v-model="selectedCountry"
													:clearable="false"
													:disabled="
														address === '' || address === null || address === undefined
													"
													:options="countriesOptions"
													:dir="$vs.rtl ? 'rtl' : 'ltr'"
													@input="getDeparments"
												>
													<template v-slot:no-options="{search, searching}">
														<template v-if="searching">
															{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
														</template>
														<template v-else>
															{{ $t("NoResultsFound") }}
														</template>
													</template>
												</v-select>
												<span class="text-danger text-sm" v-show="errors.has('pais')">{{
													$t("Deposits.Form.ValidMessages.Country")
												}}</span>
											</vs-col>
											<vs-col vs-w="6" class="pl-6">
												<label class="vs-input--label">{{
													getPoliticalDivision.department
												}}</label>
												<vs-input
													v-show="false"
													name="department"
													class="d-none"
													v-model="department.value"
													v-validate="'required'"
												/>
												<v-select
													v-model="department"
													:clearable="false"
													:loading="
														deparmentsOptions.length <= 0 && selectedCountry.value != ''
															? true
															: false
													"
													:disabled="
														deparmentsOptions.length <= 0 ||
														address === '' ||
														address === null ||
														address === undefined
													"
													:options="deparmentsOptions"
													:dir="$vs.rtl ? 'rtl' : 'ltr'"
													@input="getCities"
												>
													<template v-slot:no-options="{search, searching}">
														<template v-if="searching">
															{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
														</template>
														<template v-else>
															{{ $t("NoResultsFound") }}
														</template>
													</template>
												</v-select>
												<span class="text-danger text-sm" v-show="errors.has('department')">{{
													$t("ValidateField", {
														n: getPoliticalDivision.department.toLowerCase(),
													})
												}}</span>
											</vs-col>
											<vs-col vs-w="6" class="mt-4">
												<label class="vs-input--label">{{ getPoliticalDivision.city }}</label>
												<vs-input
													v-show="false"
													name="city"
													class="d-none"
													v-model="city.value"
													v-validate="'required'"
												/>
												<v-select
													v-model="city"
													:clearable="false"
													:loading="
														citiesOptions.length <= 0 && department.value && selectedCountry
															? true
															: false
													"
													:disabled="
														citiesOptions.length <= 0 ||
														address === '' ||
														address === null ||
														address === undefined
													"
													:options="citiesOptions"
													:dir="$vs.rtl ? 'rtl' : 'ltr'"
												>
													<template v-slot:no-options="{search, searching}">
														<template v-if="searching">
															{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
														</template>
														<template v-else>
															{{ $t("NoResultsFound") }}
														</template>
													</template>
												</v-select>
												<span class="text-danger text-sm" v-show="errors.has('city')">{{
													$t("ValidateField", {n: getPoliticalDivision.city.toLowerCase()})
												}}</span>
											</vs-col>
											<vs-col vs-w="6" class="pl-4 mt-4">
												<vs-button
													class="mt-6 w-full"
													:disabled="!address || city.value == ''"
													@click="searchAddress"
													>{{ $t("Divipola.GeoSearch") }}
												</vs-button>
											</vs-col>
										</vs-row>
									</vs-col>
								</vs-row>
							</div>
							<div class="vx-col lg:w-1/2 w-full">
								<form class="available-height">
									<div id="MapContainer">
										<div
											id="map-with-loading"
											class="map-custom-container vs-con-loading__container w-full"
										>
											<google-maps
												v-if="showMap"
												ref="GoogleMaps"
												name="map-depot"
												latitude="4.686699"
												longitude="-74.0837187"
												zoom="13"
												theme="uber"
												calledFrom="visitpoint"
											></google-maps>
										</div>
									</div>
								</form>
							</div>
						</div>
					</vx-card>
				</form>
			</vs-col>
			<vs-prompt
				:title="dataGeo.status"
				:active.sync="activePrompt"
				@cancel="dataGeo.address1 = ''"
				@accept="acceptAlert"
				@close="close"
			>
				<div class="con-exemple-prompt">
					<p>
						{{ $t("Deposits.Form.GeoRef.Finded") }}
					</p>
					<vs-input
						placeholder="Code"
						vs-placeholder="Code"
						v-model="dataGeo.address1"
						class="mt-3 w-full mb-4"
					/>
					<p>{{ $t("Deposits.Form.GeoRef.UseVisitPoint") }}</p>
				</div>
			</vs-prompt>
		</vs-row>
	</div>
</template>
<script>
import Api from "@/helpers/api.js";
import moduleDepot from "@/store/depot/moduleDepot.js";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import GoogleMaps from "@/components/Maps/Maps.vue";
import moduleMap from "@/store/map/moduleMap.js";
import depositImgRed from "@/assets/images/markers/deposit/office-building-8-red.png";
import depositImgGreen from "@/assets/images/markers/deposit/office-building-8-green.png";
import moduleCommon from "@/store/common/moduleCommon.js";
import Divider from "../../views/components/vuesax/divider/Divider.vue";
import streetviewImg from "@/assets/images/maps/google-street-view-icon-5.png";
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";
import FloatingButtons from "@/views/FloatingButtons.vue";

export default {
	name: "DepotForm",
	mixins: [generalPurposeMixin],
	props: {
		isEditActive: {
			type: Boolean,
			required: true,
		},
		data: {
			type: Object,
		},
	},
	components: {
		vSelect,
		flatPickr,
		FloatingButtons,
		GoogleMaps,
		Divider,
	},
	data() {
		return {
			depotItem: {},
			sourcesList: [],
			SubmitButtonTitle: "",
			configdateTimePicker: {
				enableTime: true,
				enableSeconds: true,
				noCalendar: true,
				dateFormat: "H:i:S",
			},
			dataGeo: {},
			activePrompt: false,
			address: "",
			selectedCountry: {label: "", value: ""},
			countries: [],
			countriesOptions: [],
			department: {label: "", value: ""},
			departments: [],
			deparmentsOptions: [],
			cityOptions: [],
			city: {label: "", value: ""},
			citiesOptions: [],
			citySelected: null,
			cityOptionsKey: 100,
			timer: null,
			dirty: {
				countries: false,
				department: false,
				city: false,
			},
			submitButtonDisabled: false,
			marker: null,
			showMap: false,
		};
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		initSetup() {
			this.getCountries();
		},
		cancel() {
			this.$router.push("/dashboard/deposits/list");
		},
		submitForm() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					if (this.isEditActive) {
						this.updateData();
					} else {
						this.saveData();
					}
				}
			});
		},
		saveData() {
			this.$vs.loading();
			let params = {};
			if (this.sourcesList.length > 0) {
				let data = {};
				this.sourcesList.forEach((el) => {
					let ob = {
						[el.id]: [el.StartInDeposit ? 1 : 0, el.EndInDeposit ? 1 : 0],
					};
					data = {...data, ...ob};
				});
				params = {...this.depotItem};
			} else {
				params = {...this.depotItem};
			}
			params.city = this.city.value;
			params.address = this.address;
			params.department = this.department.value;
			params.country = this.selectedCountry.value;

			this.$store
				.dispatch("moduleDepot/addDepot", params)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Deposits.Messages.TitleConfirmCreate"),
						text: this.$t("Deposits.Messages.TextConfirmCreate"),
					});
					this.$vs.loading.close();
					this.$router.push("/dashboard/deposits/list");
				})
				.catch((err) => {
					this.$vs.loading.close();
					console.error(err);
					if (err.data.reason === "init_hour greater than end_hour") {
						this.$vs.notify({
							color: "danger",
							title: this.$t("Error"),
							text: this.$t("Deposits.Form.ValidMessages.InitHourHigher"),
						});
					} else {
						this.$vs.notify({
							color: "warning",
							title: this.$t("MissingFieldTitle"),
							text: this.$t("MissingField"),
						});
					}
				});
		},
		updateData() {
			this.$vs.loading();
			let params = {};
			let data = {};
			this.sourcesList.forEach((el) => {
				let ob = {
					[el.id]: [el.StartInDeposit ? 1 : 0, el.EndInDeposit ? 1 : 0],
				};
				data = {...data, ...ob};
			});
			params = this.depotItem;
			params.city = this.city.value;
			params.address = this.address;
			params.department = this.department.value;
			params.country = this.selectedCountry.value;
			// Borramos las coordenadas, para que el servicio auto genere las nuevas coordenadas solo enviandole la dirección y ciudad.
			delete params.cx;
			delete params.cy;
			this.$store
				.dispatch("moduleDepot/updateItem", params)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Deposits.Messages.TitleConfirmUpdate"),
						text: this.$t("Deposits.Messages.TextConfirmUpdate"),
					});
					this.$router.push({name: "DepositListView"});
					this.$vs.loading.close();
				})
				.catch((err) => {
					console.error(err);
					this.$vs.loading.close();
					switch (err.data.reason) {
						case "init_hour greater than end_hour":
							this.$vs.notify({
								color: "danger",
								title: this.$t("Error"),
								text: this.$t("Deposits.Form.ValidMessages.InitHourHigher"),
							});
							break;
						case "The address could not be georeferenced confirm your address":
							this.$vs.notify({
								color: "danger",
								title: this.$t("Error"),
								text: this.$t("Deposits.Form.ValidMessages.AddressNotGeoRef"),
							});
							break;

						default:
							this.$vs.notify({
								color: "warning",
								title: this.$t("MissingFieldTitle"),
								text: this.$t("MissingField"),
							});
							break;
					}
				});
		},
		searchAddress() {
			this.$vs.loading({
				container: "#map-with-loading",
				scale: 1,
				type: "sound",
			});
			let address = this.address;
			let city = this.city.value;
			let department = this.department.value;
			let country = this.selectedCountry.value;
			this.$store
				.dispatch("moduleMap/geocoder", {country, city, address, department})
				.then((res) => {
					if (res.data.latitude === "0" && res.data.longitude === "0") {
						Anuket.clearMap();
						const latitude = 4.686699;
						const longitude = -74.0837187;
						this.addMarkerVisitPoint(latitude, longitude);
						this.$vs.loading.close("#map-with-loading > .con-vs-loading");
						this.$vs.notify({
							color: "danger",
							title: this.$t("Error"),
							text: this.$t("Deposits.NotFoundAddress"),
							time: 8000,
						});
						this.submitButtonDisabled = true;
					} else {
						this.depotItem.cy = res.data.latitude;
						this.depotItem.cx = res.data.longitude;
						Anuket.clearMap();
						this.addMarkerVisitPoint(res.data.latitude, res.data.longitude);
						this.$vs.loading.close("#map-with-loading > .con-vs-loading");
						this.submitButtonDisabled = false;
						this.marker.setIcon(depositImgGreen);
					}
				})
				.catch((err) => {
					this.$vs.notify({
						color: "danger",
						title: this.$t("Error"),
						text: this.$t("Deposits.Form.ValidMessages.AddressNotGeoRefSitidata"),
						time: 5000,
					});
					this.$vs.loading.close("#map-with-loading > .con-vs-loading");
					throw new Error(err);
				});
			this.$vs.loading.close("#map-with-loading > .con-vs-loading");
		},
		getCountries() {
			if (!this.isEditActive) {
				this.dirty.countries = true;
			}
			if (this.dirty.countries) {
				this.$vs.loading();
			}

			Api.post("/divipola", {
				country: "",
				department: "",
				city: "",
				world_code: "",
				only: "country_name",
				fields: ["country_name"],
			})
				.then((res) => {
					this.countriesOptions = this.generateOptionSelect(res.data, "country_name", "country_name");
				})
				.then((r) => {
					if (this.dirty.countries) {
						this.$vs.loading.close();
					} else {
						this.dirty.countries = true;
					}
				})
				.catch((e) => {
					if (!this.dirty.countries) {
						this.$vs.loading.close();
					}
					console.error("❌ Error Getting Countries", e);
					this.$vs.notify({
						color: "danger",
						title: this.$t("Error"),
						text: this.$t("Deposits.Messages.CountriesError"),
					});
					this.submitButtonDisabled = true;
				});
		},
		goToBack() {
			this.$router.push("/dashboard/deposits/list");
		},
		getDeparments() {
			if (!this.isEditActive) {
				this.dirty.department = true;
			}
			if (this.dirty.department) {
				this.$vs.loading();
			}

			Api.post("/divipola", {
				country: this.selectedCountry.value,
				department: "",
				city: "",
				world_code: "",
				only: "department_name",
				fields: ["department_name"],
			})
				.then((res) => {
					this.deparmentsOptions = this.generateOptionSelect(res.data, "department_name", "department_name");
					if (this.dirty.department) {
						this.department = {label: "", value: ""};
						this.city = {label: "", value: ""};
						this.citiesOptions = [];
					}
				})
				.then((r) => {
					if (this.dirty.department) {
						this.$vs.loading.close();
					} else {
						this.dirty.department = true;
					}
				})
				.catch((e) => {
					console.error("❌ Error Getting Departamentos", e);
					if (!this.dirty.department) {
						this.$vs.loading.close();
					}
					this.$vs.notify({
						color: "danger",
						title: this.$t("Error"),
						text: this.$t("Deposits.Messages.DepartmentsError"),
					});
					this.submitButtonDisabled = true;
				});
		},
		getCities() {
			if (!this.isEditActive) {
				this.dirty.city = true;
			}
			if (this.dirty.city) {
				this.$vs.loading();
			}

			Api.post("/divipola", {
				country: this.selectedCountry.value,
				department: this.department.value ? this.department.value.replaceAll(",", "") : "",
				city: "",
				world_code: "",
				only: "city_name",
				fields: ["city_name"],
			})
				.then((res) => {
					this.citiesOptions = this.generateOptionSelect(res.data, "city_name", "city_name");
					if (this.dirty.city) {
						this.city = {label: "", value: ""};
					}
				})
				.then((r) => {
					if (!this.dirty.city) {
						this.$vs.loading.close();
						this.dirty.city = true;
					} else {
						this.$vs.loading.close();
					}
				})
				.catch((e) => {
					console.error("❌ Error Getting Cities", e);
					if (!this.dirty.city) {
						this.$vs.loading.close();
					}
					this.$vs.notify({
						color: "danger",
						title: this.$t("Error"),
						text: this.$t("Deposits.Messages.DepartmentsError"),
					});
					this.submitButtonDisabled = true;
				});
		},
		async divipola() {
			let data = await Api.post("/divipola");
			this.cityOptions = this.generateOptionSelect(data.data, "city_name", "city_name");
			this.cityOptionsKey++;
		},
		openStreetView() {
			this.$refs.GoogleMaps.openStreetView({
				cx: this.depotItem.cx,
				cy: this.depotItem.cy,
			});
		},
		generateInfowindowContentDepot() {
			// Diseño del contenido html del infowindows
			let $docFragment = document.createDocumentFragment();
			let $infowindowDivContent = document.createElement("div");
			$infowindowDivContent.setAttribute("id", "infoWindow");
			$infowindowDivContent.style.cssText = "text-align: justify";
			let $title = document.createElement("h4");
			let $subtitle = document.createElement("p");
			$title.textContent = `${this.$t("Deposits.Depot")}`;
			$subtitle.innerHTML = `<strong>${this.$t("Deposits.Table.Name")}:</strong> ${this.depotItem.name} `;
			let $address = document.createElement("p");
			let $avatar = document.createElement("img");
			$avatar.setAttribute("src", streetviewImg);
			$avatar.setAttribute("alt", "StreetView");
			$avatar.setAttribute("title", "StreetView");
			$avatar.className = "h-8 w-8 mr-1 cursor-pointer streetview";
			$address.innerHTML = `<strong>${this.$t("Divipola.Address")}:</strong> ${
				this.address || this.depotItem.address
			}`;
			$docFragment.appendChild($title);
			$docFragment.appendChild($subtitle);
			$docFragment.appendChild($address);
			$docFragment.appendChild($avatar);
			$infowindowDivContent.appendChild($docFragment);
			return $infowindowDivContent;
		},
		addMarkerVisitPoint(lat, lng) {
			let options = {
				draggable: true,
				icon: depositImgRed,
				title: "Current position",
				label: {
					text: "A",
					color: "#fff",
					fontSize: "11.0px",
				},
				infoWindow: {
					content: this.generateInfowindowContentDepot(),
				},
				onDragend: (e, coords) => {
					this.depotItem.cy = coords.lat;
					this.depotItem.cx = coords.lng;
					this.geoInverso({cy: coords.lat, cx: coords.lng});
				},
			};
			this.marker = Anuket.addMarker({lat, lng}, options);
			Anuket.centerMap(lat, lng, {zoom: 18});
			this.depotItem.cy = lat;
			this.depotItem.cx = lng;
		},
		geoInverso({cy, cx}) {
			this.openLoading();
			this.$store
				.dispatch("moduleMap/geoinverso", {cy, cx})
				.then((res) => {
					this.closeLoading();
					this.dataGeo = {...res.data};
					if (res.data.address1 !== this.address) {
						this.activePrompt = true;
					}
					this.marker.setIcon(depositImgGreen);
					this.submitButtonDisabled = false;
				})
				.catch((err) => {
					this.closeLoading();
					this.submitButtonDisabled = true;
					console.error(err);
				});
		},
		close() {
			this.dataGeo.address1 = "";
			this.searchAddress();
		},
		acceptAlert() {
			this.selectedCountry = {
				label: this.dataGeo.country_long_name,
				value: this.dataGeo.country_long_name,
			};
			this.department = {
				label: this.dataGeo.department1,
				value: this.dataGeo.department1,
			};
			this.city = {
				label: this.dataGeo.city1,
				value: this.dataGeo.city1,
			};
			this.address = this.dataGeo.address1;
			this.marker.infoWindow.setContent(this.generateInfowindowContentDepot());
		},
		/** generate data for any select */
		generateOptionSelect(data, propLabel, propValue) {
			if (!Array.isArray(data)) {
				return [];
			}
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		async fetchDepotDataIfEdit() {
			if (!this.isEditActive) return;
			try {
				const res = await Api.get("/depot/" + this.$route.params.id);
				this.handleDepotData(res.data);
				if (res.data.cx != undefined && res.data.cx != 0 && res.data.cy != undefined && res.data.cy != 0) {
					this.addMarkerVisitPoint(res.data.cy, res.data.cx);
					this.marker.setIcon(depositImgGreen);
				}
			} catch (err) {
				console.error("Error fetching depot data:", err);
			}
		},
		handleDepotData(data) {
			this.address = data.address;
			this.setDropdownValue(this.city, data.city);
			this.setDropdownValue(this.selectedCountry, data.country, () => this.getDeparments());
			this.setDropdownValue(this.department, data.department, () => this.getCities());
		},
		setDropdownValue(target, value, callback) {
			if (value !== undefined) {
				target.label = value;
				target.value = value;
				if (callback) {
					callback();
				}
			}
		},
		setupStreetViewListener() {
			document.addEventListener("click", (e) => {
				if (e.target.matches(".streetview")) {
					this.openStreetView();
				}
			});
		},
	},
	computed: {
		title() {
			return this.$t("Deposits.Deposit");
		},
		SubmitButtonTitleCreate() {
			return this.$t("Save");
		},
		SubmitButtonTitleEdit() {
			return this.$t("Crud.Update");
		},
	},
	mounted() {
		this.showMap = true;
		if (!moduleMap.isRegistered) {
			this.$store.registerModule("moduleMap", moduleMap);
			moduleMap.isRegistered = true;
		}
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		if (this.$store.state.moduleCommon.countries.length <= 0) {
			this.$store.dispatch("moduleCommon/getCountries").catch((error) => {
				console.error(error);
			});
		}
		if (this.isEditActive) {
			this.depotItem = Object.assign({}, this.data);
		}
		this.divipola();
	},
	created() {
		this.initSetup();
		if (!moduleDepot.isRegistered) {
			this.$store.registerModule("moduleDepot", moduleDepot);
			moduleDepot.isRegistered = true;
		}
		this.fetchDepotDataIfEdit();
		this.setupStreetViewListener();
	},
};
</script>
<style lang="scss" scoped>
.vs__selected-options {
	flex-wrap: nowrap;
	max-width: calc(100% - 25px);
}

.vs__dropdown-option {
	white-space: initial;
}

.vs__selected {
	display: block;
	white-space: nowrap;
	text-overflow: ellipsis;
	max-width: 100%;
	overflow: hidden;
}

.vs__dropdown-menu {
	max-height: 300px;
	margin-top: 1px;
}

#MapContainer .themap {
	height: 300px !important;
	width: 100% !important;
	margin-left: 0px;
	margin-right: 0px;
}
</style>
